import React from 'react';
import {BookOpen, Clock, ExternalLink, GraduationCap, User} from 'lucide-react';
import {lessonRegisterStatusEnum} from "@/lib/helper/enumType";
import toFaNumber from "@/lib/utils/number";
import {weekdayString} from "@/lib/helper/weekday";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import {Link} from "react-router-dom";
import {Tag} from 'antd'
import RenderIf from "@/components/render-if";


export const MyLessonCard = ({takeLessonInfo}) => {

    return (<div
        className="rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-gray-600 dark:border-gray-600 overflow-hidden group hover:-translate-y-1">
        <div className="p-6">
            {/* Header */}
            <div className="flex justify-between items-start mb-4">
                <div className="flex-1">
                    <h3 className="text-xl font-bold  mb-2 group-hover:text-blue-600 transition-colors duration-200">
                        <Tag color={'green'}>{toFaNumber(takeLessonInfo?.lesson?.code)}</Tag>
                        {takeLessonInfo?.lesson?.topic?.title}
                    </h3>
                    <RenderIf condition={takeLessonInfo?.lesson?.teacher}>
                        <div className="flex items-center  mb-2">
                            <User className="w-4 h-4 ml-2"/>
                            <span className="text-sm font-medium">{takeLessonInfo?.lesson?.teacher_detail?.firstname} {' '}
                                <b> {takeLessonInfo?.lesson?.teacher_detail?.lastname}</b></span>
                        </div>
                    </RenderIf>
                </div>

                <div className="flex flex-col gap-2">
            <span
                className={`px-3 py-1 rounded-full text-xs font-medium border ${lessonRegisterStatusEnum(takeLessonInfo?.status, 'color')}`}>
              {lessonRegisterStatusEnum(takeLessonInfo?.status)}
            </span>

                </div>
            </div>

            {/* Schedule Info */}
            <div className="space-y-3 mb-4">


                {(takeLessonInfo?.lesson?.times && takeLessonInfo?.lesson?.times.length > 0) &&
                    <div className="flex items-center ">
                        <Clock className="w-4 h-4 ml-2 text-green-500"/>
                        <span className="text-sm">{takeLessonInfo?.lesson?.times?.map((t, index) => (
                            <>
                                    <span className={'flex flex-wrap gap-1'}>
                                        <span className={'font-bold'}>{weekdayString(t.weekday)}</span>
                                        <span>{t.classroom.title}</span>
                                        <span>{toFaNumber(t.start)} - {toFaNumber(t.end)}</span>
                                    </span>

                            </>
                        ))} </span>
                    </div>}

                <div className="flex items-center ">
                    <GraduationCap className="w-4 h-4 ml-2 text-orange-500"/>
                    <span className="text-sm">{takeLessonInfo?.lesson?.semester?.title}</span>
                </div>
            </div>

            {/* Description */}
            {takeLessonInfo?.lesson?.title && (<p className=" text-sm mb-4 leading-relaxed">
                {takeLessonInfo?.lesson?.title}
            </p>)}

            {/* Action Buttons */}
            <div className="flex gap-3 pt-4 border-t border-gray-100">
                <Link
                    to={sprintf(URLS.student.lessons.myLesson.detail, {id: takeLessonInfo?.id})}
                    className="flex-1 bg-blue-50 hover:bg-blue-100 dark:bg-blue-950/40 dark:hover:bg-blue-900/60 py-3 px-4 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 text-sm font-medium hover:scale-105 text-blue-700 dark:text-blue-300 dark:hover:text-blue-100"
                >
                    <BookOpen className="w-4 h-4"/>
                    مشاهده جزئیات
                    <ExternalLink className="w-3 h-3"/>
                </Link>

            </div>
        </div>
    </div>);
};